import { observable, runInAction, action } from "mobx";
import { ApiResult, FieldType, ViewModelBase } from "@shoothill/core";
import { AppUrls } from "../../../../../AppUrls";
import { ServerViewModel } from "../../../../../Globals/ViewModels/ServerViewModel";
import { InductionAdminPermitListAndRelatedDTO, InductionAdminPermitListModel } from "./InductionAdminPermitListModel";

export class InductionAdminPermitListViewModel extends ViewModelBase<any> {
    public server: ServerViewModel = new ServerViewModel();

    @observable public permitListModels: InductionAdminPermitListModel[] = [];
    constructor(inductionUserId: string) {
        super();
        this.loadPermitsAndRelated(inductionUserId);
    }

    public loadPermitsAndRelated = async (id: string): Promise<ApiResult<InductionAdminPermitListAndRelatedDTO>> => {
        this.setIsLoading(true);
        let params = { id: id };

        const apiResult = await this.Post<InductionAdminPermitListAndRelatedDTO>(AppUrls.Server.Induction.GetInductionPermitsByInductionUserId, params);
        if (apiResult) {
            if (apiResult.wasSuccessful) {
                runInAction(() => {
                    this.permitListModels = [];
                    for (const permit of apiResult.payload.permitListItems) {
                        let model = new InductionAdminPermitListModel();
                        model.fromDto(permit);
                        this.permitListModels.push(model);
                    }
                });
            } else {
                console.log(apiResult.errors);
            }
        }
        this.setIsLoading(false);
        return apiResult;
    };

    @action
    public handleRowClick = (e: any, rowData: InductionAdminPermitListModel) => {
        this.history.push(AppUrls.Client.Project.Permit.View.replace(":projectid", rowData.projectId).replace(":permitId", rowData.id));
    };

    public async isFieldValid(fieldName: keyof FieldType<InductionAdminPermitListModel>, value: any): Promise<boolean> {
        let { isValid, errorMessage } = await this.validateDecorators(fieldName);

        this.setError(fieldName, errorMessage);
        this.setValid(fieldName, isValid);

        return isValid;
    }
    public afterUpdate: undefined;
    public beforeUpdate: undefined;
}
